import React from 'react';

import styles from './Reference.module.scss';

interface Props {
  children?: Array<React.ReactNode>;
}

const Reference: React.FC<Props> = (props: Props) => (
  <>
    <h6>Learn</h6>
    <div className={styles.reference}>{props.children}</div>
  </>
);

Reference.displayName = 'Reference';

export default Reference;
